import React from 'react';
import {
    Box,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Grid,
    Typography
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

const PromoCouponBannerForm = ({ banners, onChange, onAdd, onRemove }) => {
    const handleBannerChange = (index, field, value) => {
        const updatedBanners = [...banners];
        updatedBanners[index] = {
            ...updatedBanners[index],
            [field]: value
        };
        onChange(updatedBanners);
    };

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom>
                Banners
            </Typography>
            {banners.map((banner, index) => (
                <Box key={index} sx={{ mb: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Link URL"
                                value={banner.linkUrl}
                                onChange={(e) => handleBannerChange(index, 'linkUrl', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Title"
                                value={banner.title}
                                onChange={(e) => handleBannerChange(index, 'title', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Image URL"
                                value={banner.imageUrl}
                                onChange={(e) => handleBannerChange(index, 'imageUrl', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DateTimePicker
                                    label="Start Date"
                                    value={moment(banner.startDate)}
                                    onChange={(date) => handleBannerChange(index, 'startDate', date.valueOf())}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DateTimePicker
                                    label="End Date"
                                    value={moment(banner.endDate)}
                                    onChange={(date) => handleBannerChange(index, 'endDate', date.valueOf())}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Page Type</InputLabel>
                                <Select
                                    multiple
                                    value={banner.pageType}
                                    onChange={(e) => handleBannerChange(index, 'pageType', e.target.value)}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value="all">All Pages</MenuItem>
                                    <MenuItem value="home">Home</MenuItem>
                                    <MenuItem value="earn">Earn</MenuItem>
                                    <MenuItem value="redeem">Redeem</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {banners.length > 1 && (
                            <Grid item xs={12}>
                                <IconButton
                                    color="error"
                                    onClick={() => onRemove(index)}
                                    sx={{ mt: 1 }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            ))}
            <Box sx={{ mt: 2 }}>
                <IconButton
                    color="primary"
                    onClick={onAdd}
                    sx={{ mr: 1 }}
                >
                    Add Banner
                </IconButton>
            </Box>
        </Box>
    );
};

export default PromoCouponBannerForm; 